export enum ChatVersions {
    /**
     * virt-chat
     */
    VT,
    /**
     * sex chat
     */
    SX
}